import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { profileLayoutDesktopFrameStyles } from '@/features/Profile/core/ProfileLayout/ProfileLayout.styled';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 0 20px;
    background-color: ${({ theme }) => theme.palette.secondary.background};
    gap: 5px;
  }
`;

export const ActivePackages = styled.section`
  display: flex;
  flex-direction: column;
  gap: 30px;
  ${profileLayoutDesktopFrameStyles}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 20px;
    padding: 0 15px 15px;
    border-radius: 0 0 21px 21px;
  }
`;

export const Title = styled(Typography.Header).attrs({ $variant: '2' })`
  font-size: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
    font-weight: 500;
  }
`;

export const PackagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }
`;

export const EmptyMessage = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const PurchasePackages = styled.section`
  display: flex;
  flex-direction: column;
  gap: 30px;
  ${profileLayoutDesktopFrameStyles}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 20px;
    padding: 25px 15px 15px;
    border-radius: 21px;
  }
`;

export const PurchaseHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const Periods = styled.div`
  display: flex;
  align-items: center;
  width: 420px;
  height: 50px;
  padding: 5px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  border-radius: 1000px;
  background-color: ${({ theme }) => theme.palette.secondary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;

export const PeriodsSkeleton = styled(SkeletonLoader).attrs({
  appearance: 'secondary',
  width: 420,
  height: 50,
  borderRadius: 1000,
})`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;

export const PeriodButton = styled.button<{ $isActive: boolean }>`
  position: relative;
  flex: 1;
  min-width: 80px;
  height: 40px;
  text-align: center;
  border: 0;
  border-radius: 1000px;
  background-color: ${({ $isActive, theme }) =>
    $isActive ? theme.palette.primary.labels : 'transparent'};
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.palette.system.white : theme.palette.primary.labels};
  font-size: 15px;
  font-weight: 400;
  font-family: inherit;
  white-space: nowrap;
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-width: 0;
    padding: 0 5px;
  }
`;

export const PeriodPromotionBadge = styled.span`
  position: absolute;
  top: -10px;
  right: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.brand.premium1};
`;
